
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/story/[slug]",
      function () {
        return require("private-next-pages/story/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/story/[slug]"])
      });
    }
  